import api from '@/utils/api';
import {
    GET_LIST_BLOOD_GROUP,
    GET_SPECIFIC_BLOOD_GROUP,
    UPDATE_SPECIFIC_BLOOD_GROUP,
    CREATE_NEW_BLOOD_GROUP,
    REMOVE_BLOOD_GROUP,
    GET_BLOOD_GROUP_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListBloodGroup = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/blood-groups', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_BLOOD_GROUP, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getSpecificBloodGroup = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/blood-groups/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_BLOOD_GROUP, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getBloodGroupActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/blood-groups/by-active', { params: filter }).then(res => {
            //console.log(res)
            dispatch({ type: GET_BLOOD_GROUP_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createBloodGroup = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/blood-groups', data).then(res => {
            dispatch({ type: CREATE_NEW_BLOOD_GROUP, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}



export const updateBloodGroup = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/blood-groups/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_BLOOD_GROUP, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeBloodGroup = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/blood-groups`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_BLOOD_GROUP, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
